import Vue from 'vue'

const state = {
  customCheckout: null,
  cardNumber: null,
  cardCVV: null,
  cardExpiry: null
}

const getters = {
  // Acces via this.$store.getters.customCheckout
  customCheckout(state) {
    return state.customCheckout
  },
  cardNumber(state) {
    return state.cardNumber
  },
  cardCVV(state) {
    return state.cardCVV
  },
  cardExpiry(state) {
    return state.cardExpiry
  }
}
const actions = {
  initCustomCheckout({ commit }, fields) {
    commit('mInitCustomCheckout', fields)
  },
  resetCustomCheckout({ commit }) {
    commit('mResetCustomCheckout')
  }
}

const mutations = {
  mInitCustomCheckout(state, fields) {
    state.customCheckout = fields.customCheckout
    state.cardNumber = fields.cardNumber
    state.cardCVV = fields.cardCVV
    state.cardExpiry = fields.cardExpiry
  },
  mResetCustomCheckout(state) {
    state.customCheckout = null
    state.cardNumber = null
    state.cardCVV = null
    state.cardExpiry = null
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
